export const apiTypeOptions = [
  {
    label: 'asyncapi',
    value: 'asyncapi',
  },
  {
    label: 'datacontract',
    value: 'datacontract',
  },
  {
    label: 'graphql',
    value: 'graphql',
  },
  {
    label: 'grpc',
    value: 'grpc',
  },
  {
    label: 'mcp-server',
    value: 'mcp-server',
  },
  {
    label: 'openapi',
    value: 'openapi',
  },
  {
    label: 'soap',
    value: 'soap',
  },
  {
    label: 'websocket',
    value: 'websocket',
  },
  {
    label: 'other',
    value: 'other',
  },
];

// MCP Server type constant
export const MCP_SERVER_TYPE =
  apiTypeOptions.find(option => option.label === 'mcp-server')?.value ||
  'mcp-server';

// MCP Server type constant
export const DATA_CONTRACT_TYPE =
  apiTypeOptions.find(option => option.label === 'datacontract')?.value ||
  'datacontract';

export const transportTypeOptions = [
  {
    label: 'Streamable HTTP',
    value: 'streamable-http',
  },
  {
    label: 'Standard Input/Output (stdio)',
    value: 'stdio',
  },
];

export const locationOptions = [
  {
    label: 'remote',
    value: 'remote',
  },
  {
    label: 'local',
    value: 'local',
  },
];

export const authorizationMethodOptions = [
  {
    label: 'Bearer Token',
    value: 'bearer-token',
  },
  {
    label: 'OAuth 2',
    value: 'oauth2',
  },
  {
    label: 'API key',
    value: 'api-key',
  },
  {
    label: 'Workload identity (SPIFFE)',
    value: 'workload-identity-spiffe',
  },
  {
    label: 'None (internal network only)',
    value: 'none',
  },
];

export const apiDefaultValue = {
  apiVersion: 'backstage.io/v1alpha1',
  kind: 'API',
  metadata: {
    name: '',
    title: '',
    description: '',
    tags: [],
  },
  spec: {
    owner: '',
    lifecycle: '',
    type: '',
    definition: {
      $text: '',
    },
    system: '',
    remote: {
      type: '',
      location: '',
      url: '',
      authorizationMethod: '',
    },
  },
  tag: '',
  leanixId: '',
  sourceCodeRepo: '',
};

export const apiMandatoryFields = [
  {
    field: 'metadata.name',
    errorMsg: 'Name is Mandatory.',
  },
  {
    field: 'metadata.title',
    errorMsg: 'Display Name is Mandatory.',
  },
  {
    field: 'metadata.description',
    errorMsg: 'Description is Mandatory.',
  },
  {
    field: 'metadata.annotations.leanix-location',
    errorMsg:
      'LeanIX ID is filled but not validated. Please click "add" to register the LeanIX Location.',
    optionalKey: 'leanixId',
  },
  {
    field: 'spec.owner',
    errorMsg: 'Owner is Mandatory.',
  },
  {
    field: 'spec.lifecycle',
    errorMsg: 'Lifecycle is Mandatory.',
  },
  {
    field: 'spec.type',
    errorMsg: 'Type is Mandatory.',
  },
  {
    field: 'spec.definition.$text',
    errorMsg: 'API Definition is Mandatory.',
  },
];
